export function getCatalogoFiltersStorageKey(name: string) {
  return `catalogo:${name}:filters`
}

export function clearPersistedCatalogFilters(key: string) {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(getCatalogoFiltersStorageKey(key))
  } catch {
    // Ignore storage errors
  }
}

/** Elimina només la marca persistida; la resta de filtres es mantenen (p. ex. reload). */
export function clearPersistedCatalogMarcaFilter(key: string) {
  if (typeof window === 'undefined') return
  try {
    const storageKey = getCatalogoFiltersStorageKey(key)
    const raw = window.localStorage.getItem(storageKey)
    if (!raw) return

    const filters = JSON.parse(raw) as Record<string, unknown>
    if (!filters || typeof filters !== 'object') return
    if (!('marca' in filters)) return

    delete filters.marca
    if (Object.keys(filters).length === 0) {
      window.localStorage.removeItem(storageKey)
    } else {
      window.localStorage.setItem(storageKey, JSON.stringify(filters))
    }
  } catch {
    // Ignore storage errors
  }
}
